import React from 'react'
import styled from 'styled-components'

import { CONFIGURE, LEFT, RIGHT, VIEW, WIDTH } from '../../constants'

type DrawerProps = {
    title: string
    mode: typeof CONFIGURE | typeof VIEW
    side: typeof LEFT | typeof RIGHT
    isOpen: boolean
    onClose: () => void
    onView: () => void
    onConfigure: () => void
    setSide: (side: React.SetStateAction<DrawerProps['side']>) => void
    children: React.ReactNode
}

const Drawer = (props: DrawerProps): React.ReactElement => {
    const { title, children, onClose, onView, onConfigure, mode, side, setSide, isOpen } = props

    return isOpen ? (
        <StyledDrawer>
            <Controls>
                <ul>
                    <li title="Close">
                        <a onClick={onClose}>
                            <i className={'far fa-times-circle'} />
                        </a>
                    </li>
                    <li className={mode === 'view' ? 'selected' : ''} title="Open alarms">
                        <a onClick={onView}>
                            <i className={'fas fa-bell'} />
                        </a>
                    </li>
                    <li className={mode === 'configure' ? 'selected' : ''} title="Configuration">
                        <a onClick={onConfigure}>
                            <i className={'fas fa-cog'} />
                        </a>
                    </li>
                    <li title={`Move to the ${side === 'left' ? 'right' : 'left'}`}>
                        <a onClick={() => setSide(s => (s === 'left' ? 'right' : 'left'))}>
                            <i className={`fas fa-arrow-alt-to-${side === 'left' ? 'right' : 'left'}`} />
                        </a>
                    </li>
                </ul>
            </Controls>
            <DrawerInner>
                <Header>
                    <Title>{title}</Title>
                </Header>
                <Body>{children}</Body>
            </DrawerInner>
        </StyledDrawer>
    ) : null
}

const DrawerInner = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
`

const Controls = styled.div`
    padding: 5px 0;
    width: 30px;
    background: #dddee1;

    li:first-child {
        border-bottom: 1px solid #c1c1c1;
    }

    ul > li > a {
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        width: 30px;
        height: 49px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
    }

    li.selected a {
        background: #37a3ef;
        color: white;
    }
`

const StyledDrawer = styled.div`
    height: 100%;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
    display: flex;
    width: ${WIDTH}px;
`

const Header = styled.header`
    position: relative;
    padding: 16px 24px;
    color: rgba(0, 0, 0, 0.65);
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
`

const Title = styled.h2`
    margin: 0;
    color: #364159;
    font-size: 16px;
    line-height: 22px;
    font-family: SourceSansPro-Semibold;
`

const Body = styled.div`
    font-size: 14px;
    line-height: 1.5;
    padding: 24px;
    overflow: auto;
    flex: 1;
`

export default Drawer
